import { Button, Ref, Snack } from '@tblabs/truffle';
import { PlaybackMode } from "../Services/PlaybackMode";
import { Icons } from '../Utils/Icons';
import { SvgButton } from './SvgButton';


export class PlaybackModeSelector extends SvgButton
{
    constructor(mode: Ref<PlaybackMode>)
    {
        const icons = {
            [PlaybackMode.DoNotRepeat]: Icons.DoNotRepeat,
            [PlaybackMode.RepeatAll]: Icons.Repeat,
            [PlaybackMode.RepeatOne]: Icons.RepeatOne,
            [PlaybackMode.Shuffle]: Icons.Shuffle
        };
        const descriptions = {
            [PlaybackMode.DoNotRepeat]: "Do not repeat",
            [PlaybackMode.RepeatAll]: "Repeat all",
            [PlaybackMode.RepeatOne]: "Repeat one",
            [PlaybackMode.Shuffle]: "Shuffle"
        };

        super(icons[mode.value]);

        let currentIndex = 0;
        let snack: Snack;

        this.OnClick(() =>
        {
            snack?.Close();

            currentIndex += 1;
            currentIndex %= Object.keys(icons).length;
            
            mode.value = Object.keys(icons)[currentIndex] as PlaybackMode;
            this.Label(icons[mode.value]);

            snack = new Snack(descriptions[mode.value], "", { autoCloseTimeout: 800, showTimeoutBar: false, clickAnywhereToClose: true });
        });
    }
}
